import { Button, styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MainContainer = styled(Button)<Theme, { $isActive?: boolean }>(({ $isActive }) => ({
  '& span': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  background: '#0b0f14',
  border: '1px solid',
  borderColor: $isActive ? COLORS.PRIMARY : '#2d343e',
  borderRadius: 8,
  cursor: 'pointer',
  height: 159,

  '& svg': {
    height: 40,
    width: 'auto',
    marginBottom: 15,
  },

  '& img': {
    marginBottom: 15,
  },
}));
